/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_Src_1_DetailInputs */

const en_wb_support_src_1_detail = /** @type {(inputs: Wb_Support_Src_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initial consultation · €65`)
};

const lv_wb_support_src_1_detail = /** @type {(inputs: Wb_Support_Src_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirmā konsultācija · 65 €`)
};

/**
* | output |
* | --- |
* | "Initial consultation · €65" |
*
* @param {Wb_Support_Src_1_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_src_1_detail = /** @type {((inputs?: Wb_Support_Src_1_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_Src_1_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_src_1_detail(inputs)
	return en_wb_support_src_1_detail(inputs)
});